import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { ClearJunctionService } from '../services/clearjunction.service';
@Component({
    selector: 'app-clearjunctionaudit',
    templateUrl: './clearjunctionaudit.component.html',
    styleUrls: ['./clearjunctionaudit.component.css']
})
export class ClearJunctionAuditComponent implements OnInit {
    displayedColumns = [
        'data',
        'orderReference', 
        'clientOrder', 
        'currency',
        'amount', 
        'status', 
        'messageUuid', 
        'transactionType', 
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<cjunctionData>;
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private clearJunction: ClearJunctionService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: JSON.parse(jsonData),
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.clearJunction.getClearJunctionAudit(this.filter).subscribe((success) => {
                let cjunctionRes = success.map(cjunctionAudit => {
                    cjunctionAudit.createdAt = moment(cjunctionAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return cjunctionAudit;
                })
                this.dataSource = new MatTableDataSource(cjunctionRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const clearjunctionaudit = await this.dataSource.filteredData.map(x => ({
                orderReference: x.orderReference,
                clientOrder: x.clientOrder,
                currency: x.currency,
                amount: x.amount,
                status: x.status,
                messageUuid: x.messageUuid,
                transactionType: x.transactionType,
                Data: x.data,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(clearjunctionaudit, "clearjunctionaudit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface cjunctionData {
    orderReference: string,
    clientOrder: string,
    currency: number,
    amount: number,
    status: number,
    messageUuid: number,
    transactionType: number,
    data: string,
    createdAt: string,
}


// WEBPACK FOOTER //
// ./src/app/clearjunctionaudit/clearjunctionaudit.component.ts